export default __webpack_public_path__ + "f055db0cd945dc8ba82cc67b1145099d.png";